import React from 'react';
import { styled } from '@mui/material/styles';
import { SxProps, Theme } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { AudioDeviceDialog, VideoDeviceDialog } from '../DeviceDialog/DeviceDialog';
import { PSYLARIS_DARK, PSYLARIS_LIGHT_GREY } from '../../../utils/Colors';

const RightUpperCorner = styled('div')({
  position: 'absolute',
  left: '70%',
  top: '15%',
  borderRadius: '50%',
  border: '0.2px solid ' + PSYLARIS_DARK,
  color: PSYLARIS_DARK,
  size: 'xs',
  background: PSYLARIS_LIGHT_GREY,
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
  zIndex: 10000,
});

interface AVBProps {
  isAudio: boolean;
  t: any;
  dialogWrapperSx?: SxProps<Theme>;
}

interface AVBState {
  showDialog: boolean;
}

export default class AVDialogButton extends React.Component<AVBProps, AVBState> {
  constructor(props: any) {
    super(props);
    this.state = {
      showDialog: false,
    };
  }

  toggleD(showD: boolean) {
    this.setState({ showDialog: !showD });
  }

  toggleDialog() {
    this.toggleD(this.state.showDialog);
  }

  render() {
    const { t } = this.props;
    const AUDIO_TOOLTIP = t('Select audio');
    const VIDEO_TOOLTIP = t('Select video');

    let TOOLTIP_TITLE;

    const POPUP_AUDIO_DIALOG = (
      <AudioDeviceDialog
        open={this.state.showDialog}
        onClose={() => {
          this.toggleDialog();
        }}
        wrapperSx={this.props.dialogWrapperSx}
      />
    );
    const POPUP_VIDEO_DIALOG = (
      <VideoDeviceDialog
        open={this.state.showDialog}
        onClose={() => {
          this.toggleDialog();
        }}
        wrapperSx={this.props.dialogWrapperSx}
      />
    );
    let popupDialog;
    let iconFace = <ExpandLessIcon />;
    if (this.props.isAudio) {
      TOOLTIP_TITLE = AUDIO_TOOLTIP;
      popupDialog = POPUP_AUDIO_DIALOG;
    } else {
      TOOLTIP_TITLE = VIDEO_TOOLTIP;
      popupDialog = POPUP_VIDEO_DIALOG;
    }

    const chevronTestId = this.props.isAudio ? 'pwid-audio-device-dialog-open' : 'pwid-video-device-dialog-open';
    return (
      <div>
        <Tooltip title={TOOLTIP_TITLE} placement="top" PopperProps={{ disablePortal: true }}>
          <RightUpperCorner onClick={this.toggleDialog.bind(this)} data-testid={chevronTestId}>
            {iconFace}
          </RightUpperCorner>
        </Tooltip>
        {popupDialog}
      </div>
    );
  }
}
